import React, { useState } from 'react';
import Card from '../ui/Card';
import { ChevronDownIcon, ChevronRightIcon, BookOpenIcon } from 'lucide-react';
const FormulasUsedPage: React.FC = () => {
  const [expandedSections, setExpandedSections] = useState<string[]>([]);
  const toggleSection = (section: string) => {
    if (expandedSections.includes(section)) {
      setExpandedSections(expandedSections.filter(s => s !== section));
    } else {
      setExpandedSections([...expandedSections, section]);
    }
  };
  return <div data-id="element-10757">
      {/* Page Header */}
      <div className="mb-8" data-id="element-10758">
        <div className="flex items-center mb-4" data-id="element-10759">
          <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-10760">
            <BookOpenIcon size={32} className="text-blue-600" data-id="element-10761" />
          </div>
          <div data-id="element-10762">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-10763">
              Formulas Used For All Reports
            </h1>
            <p className="text-gray-600 mt-1" data-id="element-10764">
              This page documents how each KPI and report in the Varroc
              dashboard is calculated.
            </p>
          </div>
        </div>
      </div>
      {/* Introduction Card */}
      <Card className="p-6 mb-8 bg-gradient-to-br from-blue-50 to-white border-2 border-blue-100" data-id="element-10765">
        <p className="text-sm text-gray-700" data-id="element-10766">
          This page documents how each KPI and report in the Varroc dashboard is
          calculated.
        </p>
      </Card>
      {/* Sales Section */}
      <Card className="mb-4 overflow-hidden border-2 border-gray-200" data-id="element-10767">
        <button onClick={() => toggleSection('sales')} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-10768">
          <div className="flex items-center" data-id="element-10769">
            <span className="text-blue-600 mr-3" data-id="element-10770">
              {expandedSections.includes('sales') ? <ChevronDownIcon size={24} data-id="element-10771" /> : <ChevronRightIcon size={24} data-id="element-10772" />}
            </span>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-10773">Sales</h3>
          </div>
        </button>
        {expandedSections.includes('sales') && <div className="px-6 pb-6 bg-gray-50 border-t border-gray-200" data-id="element-10774">
            <div className="bg-white rounded-lg p-6 mt-4" data-id="element-10775">
              <h4 className="text-md font-bold text-gray-900 mb-4" data-id="element-10776">KPIs</h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-10777">
                <li className="pl-4" data-id="element-10778">
                  <strong data-id="element-10779">Total Sales (₹ Cr)</strong>
                  <br data-id="element-10780" />= SUM(sales_invoice_amount) / 1,00,00,000
                </li>
                <li className="pl-4" data-id="element-10781">
                  <strong data-id="element-10782">Revenue (by any dimension)</strong>
                  <br data-id="element-10783" />= SUM(revenue) filtered by product / customer / region /
                  channel
                </li>
                <li className="pl-4" data-id="element-10784">
                  <strong data-id="element-10785">YoY Growth %</strong>
                  <br data-id="element-10786" />= (Revenue_current_period -
                  Revenue_same_period_last_year) / Revenue_same_period_last_year
                  * 100
                </li>
                <li className="pl-4" data-id="element-10787">
                  <strong data-id="element-10788">OEM vs Aftermarket %</strong>
                  <br data-id="element-10789" />
                  OEM_Revenue = SUM(revenue WHERE channel = "OEM")
                  <br data-id="element-10790" />
                  Aftermarket_Revenue = SUM(revenue WHERE channel =
                  "Aftermarket")
                  <br data-id="element-10791" />
                  %OEM = OEM_Revenue / (OEM_Revenue + Aftermarket_Revenue) * 100
                  <br data-id="element-10792" />
                  %Aftermarket = Aftermarket_Revenue / Total_Revenue * 100
                </li>
                <li className="pl-4" data-id="element-10793">
                  <strong data-id="element-10794">Average Selling Price (ASP)</strong>
                  <br data-id="element-10795" />= SUM(revenue) / SUM(quantity_sold)
                </li>
                <li className="pl-4" data-id="element-10796">
                  <strong data-id="element-10797">Contribution Margin %</strong>
                  <br data-id="element-10798" />= (SUM(revenue) - SUM(variable_cost)) / SUM(revenue) *
                  100
                </li>
                <li className="pl-4" data-id="element-10799">
                  <strong data-id="element-10800">Fill Rate %</strong>
                  <br data-id="element-10801" />= SUM(quantity_shipped) / SUM(quantity_ordered) * 100
                </li>
                <li className="pl-4" data-id="element-10802">
                  <strong data-id="element-10803">On-Time In-Full (OTIF) %</strong>
                  <br data-id="element-10804" />
                  For each shipment: on_time_flag = (actual_delivery_date &lt;=
                  requested_delivery_date AND full_qty_delivered)
                  <br data-id="element-10805" />
                  OTIF % = COUNT(on_time_flag = TRUE) / COUNT(all_shipments) *
                  100
                </li>
                <li className="pl-4" data-id="element-10806">
                  <strong data-id="element-10807">Backlog %</strong>
                  <br data-id="element-10808" />
                  Backlog% = Open_Order_Value / (Open_Order_Value +
                  Delivered_Value_in_period) * 100
                </li>
                <li className="pl-4" data-id="element-10809">
                  <strong data-id="element-10810">Regional Growth %</strong>
                  <br data-id="element-10811" />
                  Region_YoY% = (Region_Revenue_current -
                  Region_Revenue_previous_year) / Region_Revenue_previous_year *
                  100
                </li>
                <li className="pl-4" data-id="element-10812">
                  <strong data-id="element-10813">Customer Margin %</strong>
                  <br data-id="element-10814" />= (SUM(revenue) - SUM(cost)) / SUM(revenue) * 100 per
                  customer
                </li>
                <li className="pl-4" data-id="element-10815">
                  <strong data-id="element-10816">Customer Weighted Contribution %</strong>
                  <br data-id="element-10817" />= Customer_Revenue / Total_Revenue * 100
                </li>
                <li className="pl-4" data-id="element-10818">
                  <strong data-id="element-10819">Cost-to-Serve Index (approximate)</strong>
                  <br data-id="element-10820" />= (Logistics_cost + Service_cost + Deductions +
                  Credit_cost) / Revenue
                </li>
                <li className="pl-4" data-id="element-10821">
                  <strong data-id="element-10822">Forecast Accuracy %</strong>
                  <br data-id="element-10823" />= 100 - ( ABS(Forecast - Actual) / Actual * 100 )
                </li>
                <li className="pl-4" data-id="element-10824">
                  <strong data-id="element-10825">Demand Variability Index</strong>
                  <br data-id="element-10826" />= Coefficient of Variation = STDDEV(monthly_demand) /
                  AVG(monthly_demand)
                </li>
                <li className="pl-4" data-id="element-10827">
                  <strong data-id="element-10828">Pipeline / RFQ Win Rate %</strong>
                  <br data-id="element-10829" />= Won_Programs / Total_Programs_Closed * 100
                </li>
              </ul>
              <h4 className="text-md font-bold text-gray-900 mb-4 mt-8" data-id="element-10830">
                Report Logic
              </h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-10831">
                <li className="pl-4" data-id="element-10832">
                  <strong data-id="element-10833">India Revenue Heatmap by State</strong>
                  <br data-id="element-10834" />→ Aggregate SUM(revenue) grouped by billing_state, color
                  by revenue bucket.
                </li>
                <li className="pl-4" data-id="element-10835">
                  <strong data-id="element-10836">24-Month Sales Trend</strong>
                  <br data-id="element-10837" />→ Group FACT_SALES_INVOICE by month(date) and
                  SUM(revenue).
                </li>
                <li className="pl-4" data-id="element-10838">
                  <strong data-id="element-10839">Sales by Product Line</strong>
                  <br data-id="element-10840" />→ SUM(revenue) grouped by DIM_PRODUCT.product_line
                  (Lighting, Electrical, Polymer, Metallic, EV).
                </li>
                <li className="pl-4" data-id="element-10841">
                  <strong data-id="element-10842">Top Customers Table</strong>
                  <br data-id="element-10843" />→ For each customer: show Revenue, Margin%, YoY%,
                  Contribution% (revenue share).
                </li>
                <li className="pl-4" data-id="element-10844">
                  <strong data-id="element-10845">OEM Sales Charts</strong>
                  <br data-id="element-10846" />→ Filter channel = "OEM", group revenue and margin by
                  OEM customer.
                </li>
                <li className="pl-4" data-id="element-10847">
                  <strong data-id="element-10848">Aftermarket Sales Charts</strong>
                  <br data-id="element-10849" />→ Filter channel = "Aftermarket", group by region,
                  dealer, SKU.
                </li>
                <li className="pl-4" data-id="element-10850">
                  <strong data-id="element-10851">Order Book vs Deliveries</strong>
                  <br data-id="element-10852" />→ Compare SUM(order_value) from FACT_SALES_ORDER with
                  SUM(shipment_value) from FACT_SHIPMENTS over time.
                </li>
                <li className="pl-4" data-id="element-10853">
                  <strong data-id="element-10854">New Business / RFQ Funnel</strong>
                  <br data-id="element-10855" />→ Count or sum annualised_value grouped by RFQ stage
                  (RFQ → Tech Review → Quote → Won → SOP).
                </li>
              </ul>
            </div>
          </div>}
      </Card>
      {/* Marketing Section */}
      <Card className="mb-4 overflow-hidden border-2 border-gray-200" data-id="element-10856">
        <button onClick={() => toggleSection('marketing')} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-10857">
          <div className="flex items-center" data-id="element-10858">
            <span className="text-blue-600 mr-3" data-id="element-10859">
              {expandedSections.includes('marketing') ? <ChevronDownIcon size={24} data-id="element-10860" /> : <ChevronRightIcon size={24} data-id="element-10861" />}
            </span>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-10862">Marketing</h3>
          </div>
        </button>
        {expandedSections.includes('marketing') && <div className="px-6 pb-6 bg-gray-50 border-t border-gray-200" data-id="element-10863">
            <div className="bg-white rounded-lg p-6 mt-4" data-id="element-10864">
              <h4 className="text-md font-bold text-gray-900 mb-4" data-id="element-10865">KPIs</h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-10866">
                <li className="pl-4" data-id="element-10867">
                  <strong data-id="element-10868">Total Marketing Spend (₹)</strong>
                  <br data-id="element-10869" />= SUM(spend_amount) from FACT_CAMPAIGN_SPEND
                </li>
                <li className="pl-4" data-id="element-10870">
                  <strong data-id="element-10871">CAC (Customer Acquisition Cost)</strong>
                  <br data-id="element-10872" />= Total_Marketing_Spend / New_Customers_Acquired
                </li>
                <li className="pl-4" data-id="element-10873">
                  <strong data-id="element-10874">CPL (Cost Per Lead)</strong>
                  <br data-id="element-10875" />= Total_Marketing_Spend / Total_Leads_Generated
                </li>
                <li className="pl-4" data-id="element-10876">
                  <strong data-id="element-10877">Lead Conversion %</strong>
                  <br data-id="element-10878" />= Leads_Converted_to_Deals / Total_Leads * 100
                </li>
                <li className="pl-4" data-id="element-10879">
                  <strong data-id="element-10880">Campaign ROI %</strong>
                  <br data-id="element-10881" />= (Attributed_Revenue - Spend) / Spend * 100
                </li>
                <li className="pl-4" data-id="element-10882">
                  <strong data-id="element-10883">Website Sessions</strong>
                  <br data-id="element-10884" />= SUM(sessions)
                </li>
                <li className="pl-4" data-id="element-10885">
                  <strong data-id="element-10886">Bounce Rate %</strong>
                  <br data-id="element-10887" />= Bounced_Sessions / Total_Sessions * 100
                </li>
                <li className="pl-4" data-id="element-10888">
                  <strong data-id="element-10889">CPC (Cost Per Click)</strong>
                  <br data-id="element-10890" />= Digital_Ad_Spend / Clicks
                </li>
                <li className="pl-4" data-id="element-10891">
                  <strong data-id="element-10892">Market Share %</strong>
                  <br data-id="element-10893" />= Your_Sales / Total_Market_Size * 100 (Total market
                  from external data)
                </li>
                <li className="pl-4" data-id="element-10894">
                  <strong data-id="element-10895">Price Competitiveness Index</strong>
                  <br data-id="element-10896" />= Your_Price / Avg_Competitor_Price * 100
                </li>
              </ul>
              <h4 className="text-md font-bold text-gray-900 mb-4 mt-8" data-id="element-10897">
                Report Logic
              </h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-10898">
                <li className="pl-4" data-id="element-10899">
                  <strong data-id="element-10900">Channel-wise Spend Distribution</strong>
                  <br data-id="element-10901" />→ SUM(spend_amount) grouped by campaign_channel (ATL,
                  BTL, Digital, Trade).
                </li>
                <li className="pl-4" data-id="element-10902">
                  <strong data-id="element-10903">Campaign Performance Table</strong>
                  <br data-id="element-10904" />→ Per campaign: Spend, Impressions, Clicks, Leads,
                  Conversions, ROI%.
                </li>
                <li className="pl-4" data-id="element-10905">
                  <strong data-id="element-10906">Digital Analytics</strong>
                  <br data-id="element-10907" />→ Use FACT_CAMPAIGN_SPEND or web analytics: group
                  sessions by source/medium, device_type, region.
                </li>
                <li className="pl-4" data-id="element-10908">
                  <strong data-id="element-10909">New Product Launch Tracker</strong>
                  <br data-id="element-10910" />→ Use milestones (concept, validation, SOP, GTM) and
                  show % completed; join early sales from FACT_SALES_INVOICE.
                </li>
                <li className="pl-4" data-id="element-10911">
                  <strong data-id="element-10912">Dealer/Distributor Performance</strong>
                  <br data-id="element-10913" />→ Combine dealer billing, support issues, and sales to
                  show revenue, growth, returns, satisfaction.
                </li>
              </ul>
            </div>
          </div>}
      </Card>
      {/* After-Sales & Service Section */}
      <Card className="mb-4 overflow-hidden border-2 border-gray-200" data-id="element-10914">
        <button onClick={() => toggleSection('aftersales')} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-10915">
          <div className="flex items-center" data-id="element-10916">
            <span className="text-blue-600 mr-3" data-id="element-10917">
              {expandedSections.includes('aftersales') ? <ChevronDownIcon size={24} data-id="element-10918" /> : <ChevronRightIcon size={24} data-id="element-10919" />}
            </span>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-10920">
              After-Sales & Service
            </h3>
          </div>
        </button>
        {expandedSections.includes('aftersales') && <div className="px-6 pb-6 bg-gray-50 border-t border-gray-200" data-id="element-10921">
            <div className="bg-white rounded-lg p-6 mt-4" data-id="element-10922">
              <h4 className="text-md font-bold text-gray-900 mb-4" data-id="element-10923">KPIs</h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-10924">
                <li className="pl-4" data-id="element-10925">
                  <strong data-id="element-10926">Total Complaints</strong>
                  <br data-id="element-10927" />= COUNT(complaint_id) from FACT_COMPLAINTS
                </li>
                <li className="pl-4" data-id="element-10928">
                  <strong data-id="element-10929">Complaint Closure Rate %</strong>
                  <br data-id="element-10930" />= Closed_Complaints / Total_Complaints * 100
                </li>
                <li className="pl-4" data-id="element-10931">
                  <strong data-id="element-10932">Average Resolution Time (hours)</strong>
                  <br data-id="element-10933" />= AVG(closed_at - opened_at) in hours
                </li>
                <li className="pl-4" data-id="element-10934">
                  <strong data-id="element-10935">% Quality-Related Issues</strong>
                  <br data-id="element-10936" />= Complaints_with_root_cause_quality / Total_Complaints
                  * 100
                </li>
                <li className="pl-4" data-id="element-10937">
                  <strong data-id="element-10938">% Fitment / Installation Errors</strong>
                  <br data-id="element-10939" />= Complaints_with_category_fitment / Total_Complaints *
                  100
                </li>
                <li className="pl-4" data-id="element-10940">
                  <strong data-id="element-10941">Warranty Cost (₹)</strong>
                  <br data-id="element-10942" />= SUM(claim_cost) from FACT_WARRANTY_CLAIMS
                </li>
                <li className="pl-4" data-id="element-10943">
                  <strong data-id="element-10944">Warranty Claims per 1,000 Units</strong>
                  <br data-id="element-10945" />= Total_Warranty_Claims / Units_Sold_in_same_period *
                  1000
                </li>
                <li className="pl-4" data-id="element-10946">
                  <strong data-id="element-10947">Repeat Failure %</strong>
                  <br data-id="element-10948" />= Claims_marked_repeat / Total_Warranty_Claims * 100
                </li>
                <li className="pl-4" data-id="element-10949">
                  <strong data-id="element-10950">FTS Field Visits Count</strong>
                  <br data-id="element-10951" />= COUNT(visit_id) from FACT_FTS_VISITS
                </li>
                <li className="pl-4" data-id="element-10952">
                  <strong data-id="element-10953">First Visit Resolution %</strong>
                  <br data-id="element-10954" />= Tickets_Resolved_On_First_Visit / Tickets_Visited *
                  100
                </li>
                <li className="pl-4" data-id="element-10955">
                  <strong data-id="element-10956">Diagnostic Success Rate %</strong>
                  <br data-id="element-10957" />= Visits_where_root_cause_identified / Total_Visits *
                  100
                </li>
                <li className="pl-4" data-id="element-10958">
                  <strong data-id="element-10959">Spare Parts Fill Rate %</strong>
                  <br data-id="element-10960" />= SUM(spare_shipped_qty) / SUM(spare_ordered_qty) * 100
                </li>
                <li className="pl-4" data-id="element-10961">
                  <strong data-id="element-10962">Backorder Value (₹)</strong>
                  <br data-id="element-10963" />= SUM(order_value WHERE status="Backorder")
                </li>
                <li className="pl-4" data-id="element-10964">
                  <strong data-id="element-10965">Slow-Moving Parts %</strong>
                  <br data-id="element-10966" />= Count(SKUs with low_velocity_flag) / Count(All_SKUs) *
                  100
                </li>
                <li className="pl-4" data-id="element-10967">
                  <strong data-id="element-10968">Returns & Reverse Logistics KPIs:</strong>
                  <br data-id="element-10969" />- Total Returns (Units) = SUM(return_qty)
                  <br data-id="element-10970" />- Valid Return % = Valid_Returns / Total_Returns * 100
                  <br data-id="element-10971" />- Transit Damage Cases = COUNT(returns WHERE
                  transit_damage_flag=TRUE)
                  <br data-id="element-10972" />- Scrap vs Salvage Value = SUM(scrap_value) vs
                  SUM(salvage_value)
                </li>
                <li className="pl-4" data-id="element-10973">
                  <strong data-id="element-10974">NPS (B2B)</strong>
                  <br data-id="element-10975" />= (%Promoters - %Detractors) from 0–10 ratings
                </li>
                <li className="pl-4" data-id="element-10976">
                  <strong data-id="element-10977">Service Satisfaction Score</strong>
                  <br data-id="element-10978" />= AVG(service_rating), scaled to 0–100 if needed
                </li>
              </ul>
              <h4 className="text-md font-bold text-gray-900 mb-4 mt-8" data-id="element-10979">
                Report Logic
              </h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-10980">
                <li className="pl-4" data-id="element-10981">
                  <strong data-id="element-10982">Complaints Trend</strong>
                  <br data-id="element-10983" />→ COUNT(complaints) grouped by month and category.
                </li>
                <li className="pl-4" data-id="element-10984">
                  <strong data-id="element-10985">Warranty Failure Pareto</strong>
                  <br data-id="element-10986" />→ SUM(claim_count or claim_cost) grouped by failure_mode
                  (electrical, mechanical, LED driver, connector, housing).
                </li>
                <li className="pl-4" data-id="element-10987">
                  <strong data-id="element-10988">Field Technical Support Performance</strong>
                  <br data-id="element-10989" />→ From FACT_FTS_VISITS: visits per engineer, per region,
                  breakdown by visit_type.
                </li>
                <li className="pl-4" data-id="element-10990">
                  <strong data-id="element-10991">Dealer & Distributor Support</strong>
                  <br data-id="element-10992" />→ From FACT_DEALER_SUPPORT_REQUESTS: requests,
                  resolution times, satisfaction scores by dealer/state.
                </li>
                <li className="pl-4" data-id="element-10993">
                  <strong data-id="element-10994">Failure Analysis & Field Quality</strong>
                  <br data-id="element-10995" />→ Link FACT_WARRANTY_CLAIMS + FACT_COMPLAINTS +
                  DIM_FAILURE_MODE; show Paretos, hotspots, repeat failures.
                </li>
                <li className="pl-4" data-id="element-10996">
                  <strong data-id="element-10997">Spare Parts Performance</strong>
                  <br data-id="element-10998" />→ From FACT_INVENTORY_SNAPSHOT + FACT_RETURNS + spare
                  orders; show fill rate, ageing, fast vs slow movers.
                </li>
                <li className="pl-4" data-id="element-10999">
                  <strong data-id="element-11000">Training & Knowledge Enablement</strong>
                  <br data-id="element-11001" />→ From FACT_TRAINING: sessions, participants, topics;
                  link to post-training reduction in complaints.
                </li>
              </ul>
            </div>
          </div>}
      </Card>
      {/* Finance Section */}
      <Card className="mb-4 overflow-hidden border-2 border-gray-200" data-id="element-11002">
        <button onClick={() => toggleSection('finance')} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-11003">
          <div className="flex items-center" data-id="element-11004">
            <span className="text-blue-600 mr-3" data-id="element-11005">
              {expandedSections.includes('finance') ? <ChevronDownIcon size={24} data-id="element-11006" /> : <ChevronRightIcon size={24} data-id="element-11007" />}
            </span>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-11008">Finance</h3>
          </div>
        </button>
        {expandedSections.includes('finance') && <div className="px-6 pb-6 bg-gray-50 border-t border-gray-200" data-id="element-11009">
            <div className="bg-white rounded-lg p-6 mt-4" data-id="element-11010">
              <h4 className="text-md font-bold text-gray-900 mb-4" data-id="element-11011">KPIs</h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11012">
                <li className="pl-4" data-id="element-11013">
                  <strong data-id="element-11014">Revenue (₹ Cr)</strong>
                  <br data-id="element-11015" />= SUM(revenue) / 1,00,00,000
                </li>
                <li className="pl-4" data-id="element-11016">
                  <strong data-id="element-11017">Gross Margin %</strong>
                  <br data-id="element-11018" />= (Revenue - COGS) / Revenue * 100
                </li>
                <li className="pl-4" data-id="element-11019">
                  <strong data-id="element-11020">EBITDA %</strong>
                  <br data-id="element-11021" />= EBITDA / Revenue * 100
                </li>
                <li className="pl-4" data-id="element-11022">
                  <strong data-id="element-11023">PAT %</strong>
                  <br data-id="element-11024" />= PAT / Revenue * 100
                </li>
                <li className="pl-4" data-id="element-11025">
                  <strong data-id="element-11026">Material Cost %</strong>
                  <br data-id="element-11027" />= Material_Cost / Revenue * 100
                </li>
                <li className="pl-4" data-id="element-11028">
                  <strong data-id="element-11029">Labour Cost %</strong>
                  <br data-id="element-11030" />= Labour_Cost / Revenue * 100
                </li>
                <li className="pl-4" data-id="element-11031">
                  <strong data-id="element-11032">Overhead Cost %</strong>
                  <br data-id="element-11033" />= Overhead_Cost / Revenue * 100
                </li>
                <li className="pl-4" data-id="element-11034">
                  <strong data-id="element-11035">DSO (Days Sales Outstanding)</strong>
                  <br data-id="element-11036" />= (Trade_Receivables / Credit_Sales) * Days_in_period
                </li>
                <li className="pl-4" data-id="element-11037">
                  <strong data-id="element-11038">DPO (Days Payables Outstanding)</strong>
                  <br data-id="element-11039" />= (Trade_Payables / Credit_Purchases) * Days_in_period
                </li>
                <li className="pl-4" data-id="element-11040">
                  <strong data-id="element-11041">DIO (Days Inventory Outstanding)</strong>
                  <br data-id="element-11042" />= (Average_Inventory / COGS) * Days_in_period
                </li>
                <li className="pl-4" data-id="element-11043">
                  <strong data-id="element-11044">Cash Conversion Cycle</strong>
                  <br data-id="element-11045" />= DIO + DSO - DPO
                </li>
                <li className="pl-4" data-id="element-11046">
                  <strong data-id="element-11047">Capex Utilisation %</strong>
                  <br data-id="element-11048" />= Capex_Spent / Capex_Approved * 100
                </li>
                <li className="pl-4" data-id="element-11049">
                  <strong data-id="element-11050">Capex ROI %</strong>
                  <br data-id="element-11051" />= Incremental_Annual_Profit / Capex_Spent * 100
                </li>
                <li className="pl-4" data-id="element-11052">
                  <strong data-id="element-11053">Cost per Unit</strong>
                  <br data-id="element-11054" />= Total_Plant_Cost / Units_Produced
                </li>
              </ul>
              <h4 className="text-md font-bold text-gray-900 mb-4 mt-8" data-id="element-11055">
                Report Logic
              </h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11056">
                <li className="pl-4" data-id="element-11057">
                  <strong data-id="element-11058">P&L by Business Line</strong>
                  <br data-id="element-11059" />→ Map GL accounts & cost centers to business_line;
                  aggregate revenue, costs, margins.
                </li>
                <li className="pl-4" data-id="element-11060">
                  <strong data-id="element-11061">Working Capital Dashboard</strong>
                  <br data-id="element-11062" />→ Use monthly snapshots of receivables, payables,
                  inventory; compute DSO, DPO, DIO, CCC.
                </li>
                <li className="pl-4" data-id="element-11063">
                  <strong data-id="element-11064">Scenario Modelling</strong>
                  <br data-id="element-11065" />→ Adjust Material_Cost by +X% or FX rate, recompute
                  margin and show variations.
                </li>
              </ul>
            </div>
          </div>}
      </Card>
      {/* Supply Chain Section */}
      <Card className="mb-4 overflow-hidden border-2 border-gray-200" data-id="element-11066">
        <button onClick={() => toggleSection('supplychain')} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-11067">
          <div className="flex items-center" data-id="element-11068">
            <span className="text-blue-600 mr-3" data-id="element-11069">
              {expandedSections.includes('supplychain') ? <ChevronDownIcon size={24} data-id="element-11070" /> : <ChevronRightIcon size={24} data-id="element-11071" />}
            </span>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-11072">Supply Chain</h3>
          </div>
        </button>
        {expandedSections.includes('supplychain') && <div className="px-6 pb-6 bg-gray-50 border-t border-gray-200" data-id="element-11073">
            <div className="bg-white rounded-lg p-6 mt-4" data-id="element-11074">
              <h4 className="text-md font-bold text-gray-900 mb-4" data-id="element-11075">KPIs</h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11076">
                <li className="pl-4" data-id="element-11077">
                  <strong data-id="element-11078">Supplier Fill Rate %</strong>
                  <br data-id="element-11079" />= Delivered_Qty / Ordered_Qty * 100
                </li>
                <li className="pl-4" data-id="element-11080">
                  <strong data-id="element-11081">Supplier On-Time Delivery %</strong>
                  <br data-id="element-11082" />= On_Time_Deliveries / Total_Deliveries * 100
                </li>
                <li className="pl-4" data-id="element-11083">
                  <strong data-id="element-11084">Quality Rejection %</strong>
                  <br data-id="element-11085" />= Rejected_Qty / Received_Qty * 100
                </li>
                <li className="pl-4" data-id="element-11086">
                  <strong data-id="element-11087">Average Lead Time (days)</strong>
                  <br data-id="element-11088" />= AVG(actual_delivery_date - po_date)
                </li>
                <li className="pl-4" data-id="element-11089">
                  <strong data-id="element-11090">Logistics Delayed Shipments %</strong>
                  <br data-id="element-11091" />= Delayed_Shipments / Total_Shipments * 100
                </li>
                <li className="pl-4" data-id="element-11092">
                  <strong data-id="element-11093">Shortage Alerts (Count)</strong>
                  <br data-id="element-11094" />= COUNT(SKU WHERE Projected_Inventory &lt; Safety_Stock)
                </li>
                <li className="pl-4" data-id="element-11095">
                  <strong data-id="element-11096">Import Spend (₹ Cr)</strong>
                  <br data-id="element-11097" />= SUM(import_value) / 1,00,00,000
                </li>
                <li className="pl-4" data-id="element-11098">
                  <strong data-id="element-11099">Export Revenue (₹ Cr)</strong>
                  <br data-id="element-11100" />= SUM(export_value) / 1,00,00,000
                </li>
                <li className="pl-4" data-id="element-11101">
                  <strong data-id="element-11102">FX Exposure %</strong>
                  <br data-id="element-11103" />= FX_Denominated_Balance / Total_Balance * 100
                </li>
              </ul>
              <h4 className="text-md font-bold text-gray-900 mb-4 mt-8" data-id="element-11104">
                Report Logic
              </h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11105">
                <li className="pl-4" data-id="element-11106">
                  <strong data-id="element-11107">Supply Chain Overview</strong>
                  <br data-id="element-11108" />→ Show OTIF, fill rate, average lead time from
                  FACT_SUPPLIER_DELIVERY.
                </li>
                <li className="pl-4" data-id="element-11109">
                  <strong data-id="element-11110">Vendor Performance</strong>
                  <br data-id="element-11111" />→ Combine delivery timeliness, rejection %, and price
                  trends per supplier.
                </li>
                <li className="pl-4" data-id="element-11112">
                  <strong data-id="element-11113">Procurement Cost Trends</strong>
                  <br data-id="element-11114" />→ Track material prices and PO prices over time by
                  commodity and supplier.
                </li>
                <li className="pl-4" data-id="element-11115">
                  <strong data-id="element-11116">Lead Time & Logistics</strong>
                  <br data-id="element-11117" />→ Map shipments to lanes/routes and compute average
                  transit time and delay%.
                </li>
                <li className="pl-4" data-id="element-11118">
                  <strong data-id="element-11119">Material Shortage & Risk</strong>
                  <br data-id="element-11120" />→ Use inventory projections + demand forecast to flag
                  risky SKUs.
                </li>
              </ul>
            </div>
          </div>}
      </Card>
      {/* Manufacturing & Quality Section */}
      <Card className="mb-4 overflow-hidden border-2 border-gray-200" data-id="element-11121">
        <button onClick={() => toggleSection('manufacturing')} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-11122">
          <div className="flex items-center" data-id="element-11123">
            <span className="text-blue-600 mr-3" data-id="element-11124">
              {expandedSections.includes('manufacturing') ? <ChevronDownIcon size={24} data-id="element-11125" /> : <ChevronRightIcon size={24} data-id="element-11126" />}
            </span>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-11127">
              Manufacturing & Quality
            </h3>
          </div>
        </button>
        {expandedSections.includes('manufacturing') && <div className="px-6 pb-6 bg-gray-50 border-t border-gray-200" data-id="element-11128">
            <div className="bg-white rounded-lg p-6 mt-4" data-id="element-11129">
              <h4 className="text-md font-bold text-gray-900 mb-4" data-id="element-11130">KPIs</h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11131">
                <li className="pl-4" data-id="element-11132">
                  <strong data-id="element-11133">Units Produced</strong>
                  <br data-id="element-11134" />= SUM(units_produced) from FACT_PRODUCTION
                </li>
                <li className="pl-4" data-id="element-11135">
                  <strong data-id="element-11136">Good Units</strong>
                  <br data-id="element-11137" />= SUM(good_units)
                </li>
                <li className="pl-4" data-id="element-11138">
                  <strong data-id="element-11139">Scrap Units</strong>
                  <br data-id="element-11140" />= SUM(rejected_units)
                </li>
                <li className="pl-4" data-id="element-11141">
                  <strong data-id="element-11142">Scrap Rate %</strong>
                  <br data-id="element-11143" />= Scrap_Units / Total_Produced * 100
                </li>
                <li className="pl-4" data-id="element-11144">
                  <strong data-id="element-11145">Rework %</strong>
                  <br data-id="element-11146" />= Reworked_Units / Units_Produced * 100
                </li>
                <li className="pl-4" data-id="element-11147">
                  <strong data-id="element-11148">Cost per Unit</strong>
                  <br data-id="element-11149" />= Total_Mfg_Cost / Units_Produced
                </li>
                <li className="pl-4" data-id="element-11150">
                  <strong data-id="element-11151">Availability (OEE component)</strong>
                  <br data-id="element-11152" />= Runtime / Planned_Production_Time
                </li>
                <li className="pl-4" data-id="element-11153">
                  <strong data-id="element-11154">Performance (OEE component)</strong>
                  <br data-id="element-11155" />= (Ideal_Cycle_Time * Total_Units) / Runtime
                </li>
                <li className="pl-4" data-id="element-11156">
                  <strong data-id="element-11157">Quality (OEE component)</strong>
                  <br data-id="element-11158" />= Good_Units / Total_Units
                </li>
                <li className="pl-4" data-id="element-11159">
                  <strong data-id="element-11160">OEE %</strong>
                  <br data-id="element-11161" />= Availability * Performance * Quality * 100
                </li>
                <li className="pl-4" data-id="element-11162">
                  <strong data-id="element-11163">MTTR (Mean Time To Repair)</strong>
                  <br data-id="element-11164" />= AVG(Time_to_repair_minutes) across downtime events
                </li>
                <li className="pl-4" data-id="element-11165">
                  <strong data-id="element-11166">MTBF (Mean Time Between Failures)</strong>
                  <br data-id="element-11167" />= Total_Runtime / Number_of_Failures
                </li>
                <li className="pl-4" data-id="element-11168">
                  <strong data-id="element-11169">PPM (Defects per million)</strong>
                  <br data-id="element-11170" />= (Defective_Units / Units_Produced) * 1,000,000
                </li>
                <li className="pl-4" data-id="element-11171">
                  <strong data-id="element-11172">kWh per Unit</strong>
                  <br data-id="element-11173" />= Total_kWh / Units_Produced
                </li>
              </ul>
              <h4 className="text-md font-bold text-gray-900 mb-4 mt-8" data-id="element-11174">
                Report Logic
              </h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11175">
                <li className="pl-4" data-id="element-11176">
                  <strong data-id="element-11177">Production Output</strong>
                  <br data-id="element-11178" />→ Group FACT_PRODUCTION by plant, line, product, shift;
                  sum output.
                </li>
                <li className="pl-4" data-id="element-11179">
                  <strong data-id="element-11180">Capacity Utilisation</strong>
                  <br data-id="element-11181" />→ Compare Runtime or Actual_Units vs Rated_Capacity or
                  Planned_Time.
                </li>
                <li className="pl-4" data-id="element-11182">
                  <strong data-id="element-11183">Downtime Analysis</strong>
                  <br data-id="element-11184" />→ Use FACT_DOWNTIME: group by cause, line, plant; show
                  Pareto and trends.
                </li>
                <li className="pl-4" data-id="element-11185">
                  <strong data-id="element-11186">Quality Metrics</strong>
                  <br data-id="element-11187" />→ From FACT_QUALITY_INSPECTION: defects by type, PPM by
                  product, trend over time.
                </li>
                <li className="pl-4" data-id="element-11188">
                  <strong data-id="element-11189">Scrap Cost Analysis</strong>
                  <br data-id="element-11190" />→ Scrap_Cost = Scrap_Units * Standard_Cost_per_Unit
                  grouped by product line and plant.
                </li>
                <li className="pl-4" data-id="element-11191">
                  <strong data-id="element-11192">Energy Dashboards</strong>
                  <br data-id="element-11193" />→ Use FACT_ENERGY_CONSUMPTION: kWh, energy_cost per
                  plant/line/unit.
                </li>
              </ul>
            </div>
          </div>}
      </Card>
      {/* Audits & Compliance Section */}
      <Card className="mb-4 overflow-hidden border-2 border-gray-200" data-id="element-11194">
        <button onClick={() => toggleSection('audits')} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-11195">
          <div className="flex items-center" data-id="element-11196">
            <span className="text-blue-600 mr-3" data-id="element-11197">
              {expandedSections.includes('audits') ? <ChevronDownIcon size={24} data-id="element-11198" /> : <ChevronRightIcon size={24} data-id="element-11199" />}
            </span>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-11200">
              Audits & Compliance
            </h3>
          </div>
        </button>
        {expandedSections.includes('audits') && <div className="px-6 pb-6 bg-gray-50 border-t border-gray-200" data-id="element-11201">
            <div className="bg-white rounded-lg p-6 mt-4" data-id="element-11202">
              <h4 className="text-md font-bold text-gray-900 mb-4" data-id="element-11203">KPIs</h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11204">
                <li className="pl-4" data-id="element-11205">
                  <strong data-id="element-11206">Audit Score %</strong>
                  <br data-id="element-11207" />= Scored_Points / Total_Points * 100
                </li>
                <li className="pl-4" data-id="element-11208">
                  <strong data-id="element-11209">NCR Count</strong>
                  <br data-id="element-11210" />= COUNT(open NCRs)
                </li>
                <li className="pl-4" data-id="element-11211">
                  <strong data-id="element-11212">NCR Age (days)</strong>
                  <br data-id="element-11213" />= Current_Date - NCR_Open_Date
                </li>
                <li className="pl-4" data-id="element-11214">
                  <strong data-id="element-11215">CAPA Closure %</strong>
                  <br data-id="element-11216" />= Closed_CAPA / Total_CAPA * 100
                </li>
                <li className="pl-4" data-id="element-11217">
                  <strong data-id="element-11218">Repeat Issues %</strong>
                  <br data-id="element-11219" />= NCRs or findings that recur / total NCRs * 100
                </li>
                <li className="pl-4" data-id="element-11220">
                  <strong data-id="element-11221">Safety LTIFR</strong>
                  <br data-id="element-11222" />= (Lost_Time_Injuries * 1,000,000) / Total_Hours_Worked
                </li>
                <li className="pl-4" data-id="element-11223">
                  <strong data-id="element-11224">Environmental Compliance %</strong>
                  <br data-id="element-11225" />= Compliant_Samples / Total_Samples * 100
                </li>
                <li className="pl-4" data-id="element-11226">
                  <strong data-id="element-11227">Documentation Completion %</strong>
                  <br data-id="element-11228" />= Completed_Documents / Required_Documents * 100
                </li>
              </ul>
              <h4 className="text-md font-bold text-gray-900 mb-4 mt-8" data-id="element-11229">
                Report Logic
              </h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11230">
                <li className="pl-4" data-id="element-11231">
                  <strong data-id="element-11232">Internal Audits</strong>
                  <br data-id="element-11233" />→ Show scores by area (5S, safety, process) and trends
                  by plant.
                </li>
                <li className="pl-4" data-id="element-11234">
                  <strong data-id="element-11235">External OEM Audits</strong>
                  <br data-id="element-11236" />→ Audit scores by OEM, severity heatmaps, recurring
                  issue analysis.
                </li>
                <li className="pl-4" data-id="element-11237">
                  <strong data-id="element-11238">NCR & CAPA</strong>
                  <br data-id="element-11239" />→ Track open/closed status, ageing, and implementation
                  progress.
                </li>
                <li className="pl-4" data-id="element-11240">
                  <strong data-id="element-11241">Safety Incidents</strong>
                  <br data-id="element-11242" />→ Group incidents by severity, plant, type; show
                  incident trends and LTIFR.
                </li>
                <li className="pl-4" data-id="element-11243">
                  <strong data-id="element-11244">Environmental Compliance</strong>
                  <br data-id="element-11245" />→ Compare emissions, waste, and water metrics versus
                  norms.
                </li>
              </ul>
            </div>
          </div>}
      </Card>
      {/* CEO / Executive Summary Section */}
      <Card className="mb-4 overflow-hidden border-2 border-gray-200" data-id="element-11246">
        <button onClick={() => toggleSection('ceo')} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-11247">
          <div className="flex items-center" data-id="element-11248">
            <span className="text-blue-600 mr-3" data-id="element-11249">
              {expandedSections.includes('ceo') ? <ChevronDownIcon size={24} data-id="element-11250" /> : <ChevronRightIcon size={24} data-id="element-11251" />}
            </span>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-11252">
              CEO / Executive Summary
            </h3>
          </div>
        </button>
        {expandedSections.includes('ceo') && <div className="px-6 pb-6 bg-gray-50 border-t border-gray-200" data-id="element-11253">
            <div className="bg-white rounded-lg p-6 mt-4" data-id="element-11254">
              <h4 className="text-md font-bold text-gray-900 mb-4" data-id="element-11255">KPIs</h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11256">
                <li className="pl-4" data-id="element-11257">
                  <strong data-id="element-11258">Revenue (₹ Cr), EBITDA %, PAT %</strong>
                  <br data-id="element-11259" />→ From Finance aggregates.
                </li>
                <li className="pl-4" data-id="element-11260">
                  <strong data-id="element-11261">Working Capital Days</strong>
                  <br data-id="element-11262" />= DIO + DSO - DPO
                </li>
                <li className="pl-4" data-id="element-11263">
                  <strong data-id="element-11264">OEE %</strong>
                  <br data-id="element-11265" />→ Weighted or averaged across selected plants/lines.
                </li>
                <li className="pl-4" data-id="element-11266">
                  <strong data-id="element-11267">Warranty Cost (₹ Cr)</strong>
                  <br data-id="element-11268" />= SUM(warranty_claim_cost) / 1,00,00,000
                </li>
                <li className="pl-4" data-id="element-11269">
                  <strong data-id="element-11270">Field Failure Rate</strong>
                  <br data-id="element-11271" />= Field_Failures / Units_in_Field * 100 (or per 1,000)
                </li>
                <li className="pl-4" data-id="element-11272">
                  <strong data-id="element-11273">Audit Score %</strong>
                  <br data-id="element-11274" />→ Average latest audit scores across plants.
                </li>
                <li className="pl-4" data-id="element-11275">
                  <strong data-id="element-11276">NCR Open Count</strong>
                  <br data-id="element-11277" />= COUNT(NCR where status="Open")
                </li>
              </ul>
              <h4 className="text-md font-bold text-gray-900 mb-4 mt-8" data-id="element-11278">
                Report Logic
              </h4>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-11279">
                <li className="pl-4" data-id="element-11280">
                  <strong data-id="element-11281">Efficiency vs Margin Correlation</strong>
                  <br data-id="element-11282" />→ Correlate OEE or Cost_per_Unit from Manufacturing with
                  Margin% from Finance at plant or product-line level.
                </li>
                <li className="pl-4" data-id="element-11283">
                  <strong data-id="element-11284">Top 5 Risks</strong>
                  <br data-id="element-11285" />→ Highlight metrics violating thresholds (e.g., low OEE,
                  high scrap, high warranty, poor audit score, high backlog).
                </li>
                <li className="pl-4" data-id="element-11286">
                  <strong data-id="element-11287">Top 5 Opportunities</strong>
                  <br data-id="element-11288" />→ Highlight fast-growing regions, product lines,
                  high-margin customers, improving plants.
                </li>
              </ul>
            </div>
          </div>}
      </Card>
    </div>;
};
export default FormulasUsedPage;